import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import TvIcon from '@mui/icons-material/Tv';
import AlignVerticalTopIcon from '@mui/icons-material/AlignVerticalTop';
import AlignVerticalBottomIcon from '@mui/icons-material/AlignVerticalBottom';
import { Box,Card,CardHeader,CardContent,TextField,FormHelperText,InputAdornment,Divider,Button, FormLabel,Typography,IconButton,Tooltip,Dialog,DialogTitle,DialogContent,DialogActions,Grid,FormControl,InputLabel,Select,MenuItem,OutlinedInput,Chip,Stack,ToggleButton,ToggleButtonGroup,LinearProgress} from '@mui/material';
import SelectAvailableScreensNew from './SelectAvailableScreensNew';
import BasicTable2 from '../tools/BasicTable2';
import * as ETVConstants from '../ETVConstants';

class Newsticker extends React.Component {
  constructor(props) {
    super(props);
    this.selectedScreens = this.selectedScreens.bind(this);
    this.closeScreenSelection = this.closeScreenSelection.bind(this);
  }

  state = {
    items: [],
    isLoaded: false,
    isLoading: false,
    // edit/add form
    edit_id: '',
    edit_name: '',
    edit_value: '',
    edit_textColor: '#FFFFFF',
    edit_bgColor: '#000000',
    edit_size: 'medium',
    align_top: false,
    selected_screens: [],

    // async flags
    savingAdd: false,

    // windows: 'add_static_ticker_div' | 'edit_div' | 'select_screens_div' | 'message_div' | ''
    window: '',
    info_title: '',
    info_message: undefined
  };

  componentDidMount() {
    this.loadItems();
  }

  componentDidUpdate() {
    if (!this.state.isLoaded && !this.state.isLoading) {
      this.loadItems();
    }
  }

  // -------- data --------
  loadItems() {
    const accessToken = localStorage.getItem('etv.access_token');
    const reqUserID = localStorage.getItem('etv.user_id');
    const url = `${ETVConstants.getServerBase()}/marquee?action=list_marquees&user_id=${this.props.user_id}`;
    this.setState({ isLoading: true });
    fetch(url, { headers: { user_id: reqUserID, access_token: accessToken } })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({ items: result.data, isLoaded: true, isLoading: false });
        },
        () => {
          this.setState({ items: [], isLoaded: true, isLoading: false });
        }
      );
  }

  saveNewTicker() {
    //console.log("add new tickers...");
    const raw = this.state.selected_screens || [];
    const screenIDs = raw.map((v) => (typeof v === 'object' ? (v.screen_id ?? v.id ?? v.value) : v)).filter(Boolean);
    if (screenIDs.length === 0) {
      this.showInfoMessage(ETVConstants.trans('no_screen_selected'));
      return;
    }
    if (!this.state.edit_value.trim()) {
      this.showInfoMessage(ETVConstants.trans('ticker_text') + ' ' + ETVConstants.trans('required'));
      return;
    }
    this.setState({ savingAdd: true });
    let url = `${ETVConstants.getServerBase()}/marquee?action=save&bg_color=${encodeURIComponent(this.state.edit_bgColor)}&text_size=${this.state.edit_size}&text_color=${encodeURIComponent(this.state.edit_textColor)}`;
    url += `&ticker_text=${encodeURIComponent(this.state.edit_value)}`;
    // Append all selected ids
    screenIDs.forEach((id) => {
      url += `&screen_id=${id}`;
    });
    url += `&align_top=${this.state.align_top}`;
    //console.log("saveURL="+url);
    const accessToken = localStorage.getItem('etv.access_token');
    const reqUserID = localStorage.getItem('etv.user_id');
    fetch(url, { headers: { user_id: reqUserID, access_token: accessToken } })
      .then((res) => res.json())
      .then(
        () => {
          this.setState({ isLoaded: false, edit_value: '', selected_screens: [], savingAdd: false });
          this.showWindow('add_static_ticker_div', false);
        },
        (error) => {
          this.setState({ savingAdd: false });
          this.showInfoMessage('error happened: ' + error);
        }
      );
  }

  updateTicker() {
    let url = `${ETVConstants.getServerBase()}/marquee?action=save&screen_id=${this.state.edit_id}&bg_color=${encodeURIComponent(this.state.edit_bgColor)}&text_size=${this.state.edit_size}&text_color=${encodeURIComponent(this.state.edit_textColor)}`;
    url += `&ticker_text=${encodeURIComponent(this.state.edit_value)}`;
    url += `&align_top=${this.state.align_top}`;
    const accessToken = localStorage.getItem('etv.access_token');
    const reqUserID = localStorage.getItem('etv.user_id');
    fetch(url, { headers: { user_id: reqUserID, access_token: accessToken } })
      .then((res) => res.json())
      .then(
        () => {
          this.setState({ isLoaded: false, edit_id: '', edit_value: '' });
          this.showWindow('edit_div', false);
        },
        (error) => this.showInfoMessage('error happened: ' + error)
      );
  }

  deleteTicker(screenID) {
    const url = `${ETVConstants.getServerBase()}/marquee?action=delete&screen_id=${screenID}`;
    const accessToken = localStorage.getItem('etv.access_token');
    const reqUserID = localStorage.getItem('etv.user_id');
    fetch(url, { headers: { user_id: reqUserID, access_token: accessToken } })
      .then((res) => res.json())
      .then(
        () => this.setState({ isLoaded: false }),
        (error) => this.showInfoMessage('error happened: ' + error)
      );
  }

  // -------- ui helpers --------
  editTicker(screenID, screenName, tickerText, bgColor, txtColor, textSize, alignTop) {
    this.setState({
      edit_id: screenID,
      edit_name: screenName,
      edit_value: tickerText || '',
      edit_bgColor: bgColor || '#000000',
      edit_textColor: txtColor || '#FFFFFF',
      edit_size: textSize || 'medium',
      align_top: !!alignTop
    });
    this.showWindow('edit_div', true);
  }

  showAddTickerDiv() {
    this.setState({
      edit_id: '',
      edit_name: '',
      edit_value: '',
      edit_bgColor: '#000000',
      edit_textColor: '#FFFFFF',
      edit_size: 'medium',
      align_top: false,
      selected_screens: []
    });
    this.showWindow('add_static_ticker_div', true);
  }

  selectedScreens(screenIDs) {
    this.setState({ selected_screens: screenIDs, window:'add_static_ticker_div' });
  }

  closeScreenSelection() {
    this.setState({ window:'add_static_ticker_div' });
  }

  showWindow(divID, show) {
    this.setState({ window: show ? divID : '' });
  }

  showInfoMessage(msg, title) {
    this.setState({ window: 'message_div', info_message: msg, info_title: title || ETVConstants.trans('info') });
  }

  closeInfoMessage() {
    this.setState({ info_message: undefined });
    this.showWindow('message_div', false);
  }

  // form small helpers
  handleAlignChange = (_, val) => {
    if (val === null) return; // keep previous when clicking active
    this.setState({ align_top: val === 'top' });
  };

  // live preview component
  TickerPreview = ({ text, bg, fg, size, alignTop }) => {
    const sizePx = size === 'small' ? 14 : size === 'large' ? 22 : size === 'extra_large' ? 28 : 18;
    return (
        <Box sx={{
          bgcolor: bg,
          color: fg,
          px: 2,
          py: alignTop ? 1 : 1,
          borderTopLeftRadius: 5,
          borderTopRightRadius: 5,
          borderBottomLeftRadius: 5,
          borderBottomRightRadius: 5,
          minHeight: 40,
          display: 'flex',
          alignItems: alignTop ? 'flex-start' : 'flex-end'
        }}>
          <Typography sx={{ fontSize: sizePx, lineHeight: 1.3, py: 0.5 }}>{text || '—'}</Typography>
        </Box>
    );
  };

  isValidHex = (v) => /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(v?.trim() || "");
  normHex = (v) => {
    const x = (v || "").trim();
    if (!x) return "#000000";
    return x.startsWith("#") ? x.toUpperCase() : ("#" + x.toUpperCase());
  };

  render() {
    const columnsData = [
      {
        title: ETVConstants.trans('device_name'),
        field: 'screen_name',
        render: (rowData) => (
          <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 140 }}>
            <TvIcon fontSize="small" />
            <Typography variant="body2">{rowData.screen_name}</Typography>
          </Stack>
        )
      },
      {
        title: ETVConstants.trans('ticker_text'),
        field: 'ticker_text',
        render: (rowData) => (
          <Typography variant="body2" sx={{ minWidth: 280, maxWidth: 480 }} noWrap>
            {rowData.ticker_text}
          </Typography>
        )
      },
      {
        title: ETVConstants.trans('edit'),
        field: 'edit',
        render: (rowData) => (
          <Button
            size="small"
            startIcon={<EditIcon />}
            variant="contained"
            onClick={() =>
              this.editTicker(
                rowData.screen_id,
                rowData.screen_name,
                rowData.ticker_text,
                rowData.bg_color,
                rowData.text_color,
                rowData.text_size,
                rowData.align_top
              )
            }
          >
            {ETVConstants.trans('edit')}
          </Button>
        )
      },
      {
        title: ETVConstants.trans('delete'),
        field: 'delete',
        render: (rowData) => (
          <Tooltip title={ETVConstants.trans('delete')}>
            <IconButton size="small" color="error" onClick={() => this.deleteTicker(rowData.screen_id)}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )
      }
    ];
    const tabletitle = '';
    const charCount = this.state.edit_value?.length || 0;
    const tooLong = charCount > 1000; 
    return (
      <Box sx={{ width: '100%', maxWidth: 980 }}>
        <Card elevation={2} sx={{ borderRadius: 3, overflow: 'hidden'}}>
          <CardHeader
            title={
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="h6">{ETVConstants.trans('ticker_text')}</Typography>
              </Stack>
            }
            action={
              <Button variant="contained" startIcon={<AddIcon />} onClick={() => this.showAddTickerDiv()}>
                {ETVConstants.trans('add_ticker')}
              </Button>
            }
          />
          {this.state.isLoading && <LinearProgress />}
          <CardContent>
            <BasicTable2
              data={this.state.items}
              columns={columnsData}
              title={tabletitle}
              pageSize={10}
              allow_search={true}
            />
          </CardContent>
        </Card>

        {/* Screen selector */}
        {this.state.window === 'select_screens_div' && (
          <SelectAvailableScreensNew
            isOpen={true}
            user_id={this.props.user_id}
            closeHook={this.closeScreenSelection}
            selectedScreens={this.selectedScreens}
            selected={this.state.selected_screens}
          />
        )}

        {/* Add dialog */}
        <Dialog
          open={this.state.window === 'add_static_ticker_div'}
          maxWidth="sm"
          fullWidth
          onClose={() => {}}
        >
          <DialogTitle>{ETVConstants.trans('ticker_text')}
                <Chip
                  label={ETVConstants.trans('add_ticker')}
                  icon={<EditIcon />}
                  size="small"
                  sx={(t) => ({
                  borderRadius: 1,
                  fontWeight: 600,
                  backgroundColor: t.palette.action.hover,
                })}/>
          </DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel htmlFor="ticker_text">{ETVConstants.trans('ticker_text')}</InputLabel>
                  <OutlinedInput
                    id="ticker_text"
                    multiline
                    minRows={4}
                    value={this.state.edit_value}
                    onChange={(e) => this.setState({ edit_value: e.target.value })}
                    label={ETVConstants.trans('ticker_text')}
                  />
                </FormControl>
                <Stack direction="row" justifyContent="space-between" sx={{ mt: 0.5 }}>
                  <Typography variant="caption">{charCount}/500</Typography>
                  {tooLong && (
                    <Typography variant="caption" color="error">
                      {ETVConstants.trans('too_long')}
                    </Typography>
                  )}
                </Stack>
              </Grid>

              {/* font color */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth size="small">
                  <FormLabel sx={{ mb: 0.5 }}>{ETVConstants.trans('font_color')}</FormLabel>

                  <Stack direction="row" spacing={1.5} alignItems="center">
                    {/* Square swatch triggering hidden color input */}
                    <Box sx={{ position: 'relative', width: 40, height: 40, flex: '0 0 40px' }}>
                      <input
                        ref={this.fontColorRef}
                        type="color"
                        value={this.isValidHex(this.state.edit_textColor) ? this.state.edit_textColor : '#FFFFFF'}
                        onChange={(e) => this.setState({ edit_textColor: this.normHex(e.target.value) })}
                        style={{
                          position: 'absolute', inset: 0, opacity: 0,
                          width: '100%', height: '100%', cursor: 'pointer', border: 0, padding: 0,
                        }}
                        aria-label={ETVConstants.trans('font_color')}
                      />
                      <Box
                        onClick={() => this.fontColorRef.current?.click()}
                        sx={{
                          width: '100%', height: '100%', borderRadius: 1,
                          bgcolor: this.isValidHex(this.state.edit_textColor) ? this.state.edit_textColor : '#fff',
                          border: '1px solid', borderColor: 'divider',
                        }}
                      />
                    </Box>

                    {/* Hex input */}
                    <OutlinedInput
                      value={this.state.edit_textColor}
                      onChange={(e) => this.setState({ edit_textColor: this.normHex(e.target.value) })}
                      onBlur={(e) => this.setState({ edit_textColor: this.normHex(e.target.value) })}
                      size="small"
                      fullWidth
                      startAdornment={
                        <InputAdornment position="start">
                          <Box
                            sx={{
                              width: 16, height: 16, borderRadius: 0.5,
                              bgcolor: this.isValidHex(this.state.edit_textColor) ? this.state.edit_textColor : '#fff',
                              border: '1px solid', borderColor: 'divider',
                            }}
                          />
                        </InputAdornment>
                      }
                      error={!this.isValidHex(this.state.edit_textColor)}
                      sx={{
                        height: 40, // match swatch height
                        '& .MuiInputBase-input': {
                          fontFamily:
                            'ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace',
                          textTransform: 'uppercase',
                          letterSpacing: 0.3,
                          py: 0.5,
                        },
                      }}
                    />
                  </Stack>

                  <FormHelperText error={!this.isValidHex(this.state.edit_textColor)}>
                    {!this.isValidHex(this.state.edit_textColor) ? ETVConstants.trans('invalid_hex') : ' '}
                  </FormHelperText>
                </FormControl>
              </Grid>

              {/* Background color */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth size="small">
                  <FormLabel sx={{ mb: 0.5 }}>{ETVConstants.trans('background_color')}</FormLabel>

                  <Stack direction="row" spacing={1.5} alignItems="center">
                    {/* Square swatch triggering hidden color input */}
                    <Box sx={{ position: 'relative', width: 40, height: 40, flex: '0 0 40px' }}>
                      <input
                        ref={this.bgColorRef}
                        type="color"
                        value={this.isValidHex(this.state.edit_bgColor) ? this.state.edit_bgColor : '#000000'}
                        onChange={(e) => this.setState({ edit_bgColor: this.normHex(e.target.value) })}
                        style={{
                          position: 'absolute', inset: 0, opacity: 0,
                          width: '100%', height: '100%', cursor: 'pointer', border: 0, padding: 0,
                        }}
                        aria-label={ETVConstants.trans('background_color')}
                      />
                      <Box
                        onClick={() => this.bgColorRef.current?.click()}
                        sx={{
                          width: '100%', height: '100%', borderRadius: 1,
                          bgcolor: this.isValidHex(this.state.edit_bgColor) ? this.state.edit_bgColor : '#000',
                          border: '1px solid', borderColor: 'divider',
                        }}
                      />
                    </Box>

                    {/* Hex input */}
                    <OutlinedInput
                      value={this.state.edit_bgColor}
                      onChange={(e) => this.setState({ edit_bgColor: this.normHex(e.target.value) })}
                      onBlur={(e) => this.setState({ edit_bgColor: this.normHex(e.target.value) })}
                      size="small"
                      fullWidth
                      startAdornment={
                        <InputAdornment position="start">
                          <Box
                            sx={{
                              width: 16, height: 16, borderRadius: 0.5,
                              bgcolor: this.isValidHex(this.state.edit_bgColor) ? this.state.edit_bgColor : '#000',
                              border: '1px solid', borderColor: 'divider',
                            }}
                          />
                        </InputAdornment>
                      }
                      error={!this.isValidHex(this.state.edit_bgColor)}
                      sx={{
                        height: 40, // match swatch
                        '& .MuiInputBase-input': {
                          fontFamily:
                            'ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace',
                          textTransform: 'uppercase',
                          letterSpacing: 0.3,
                          py: 0.5,
                        },
                      }}
                    />
                  </Stack>

                  <FormHelperText error={!this.isValidHex(this.state.edit_bgColor)}>
                    {!this.isValidHex(this.state.edit_bgColor) ? ETVConstants.trans('invalid_hex') : ' '}
                  </FormHelperText>
                </FormControl>
              </Grid>

              {/* Text size */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth size="small">
                  <FormLabel sx={{ mb: 0.5 }}>{ETVConstants.trans('text_size')}</FormLabel>
                  <Select
                    id="text_size"
                    value={this.state.edit_size}
                    onChange={(e) => this.setState({ edit_size: e.target.value })}
                    displayEmpty
                    inputProps={{ 'aria-label': ETVConstants.trans('text_size') }}
                    sx={{ height: 40, '& .MuiSelect-select': { py: 0.5 } }}
                  >
                    <MenuItem value="small">{ETVConstants.trans('small')}</MenuItem>
                    <MenuItem value="medium">{ETVConstants.trans('medium')}</MenuItem>
                    <MenuItem value="large">{ETVConstants.trans('large')}</MenuItem>
                    <MenuItem value="extra_large">{ETVConstants.trans('extra_large')}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* Alignment */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth size="small">
                  <FormLabel sx={{ mb: 0.5 }}>{ETVConstants.trans('alignment')}</FormLabel>
                  <Box sx={{ display: 'flex' }}>
                    <ToggleButtonGroup
                      value={this.state.align_top ? 'top' : 'bottom'}
                      exclusive
                      onChange={this.handleAlignChange}
                      size="small"
                      sx={{
                        '& .MuiToggleButton-root': {
                          height: 40,            // match Select
                          px: 1.5,
                        },
                        '& .Mui-selected': { fontWeight: 600 },
                      }}
                    >
                      <ToggleButton value="top" disableRipple>
                        <AlignVerticalTopIcon sx={{ mr: 1 }} fontSize="small" />
                        {ETVConstants.trans('top')}
                      </ToggleButton>
                      <ToggleButton value="bottom" disableRipple>
                        <AlignVerticalBottomIcon sx={{ mr: 1 }} fontSize="small" />
                        {ETVConstants.trans('bottom')}
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Button
                  variant="outlined"
                  onClick={() => this.showWindow('select_screens_div', true)}
                  startIcon={<TvIcon />}
                >
                  {ETVConstants.trans('select_screens')} ({this.state.selected_screens.length})
                </Button>
              </Grid>

              <Grid item xs={12}>
                <this.TickerPreview
                  text={this.state.edit_value}
                  bg={this.state.edit_bgColor}
                  fg={this.state.edit_textColor}
                  size={this.state.edit_size}
                  alignTop={this.state.align_top}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.showWindow('add_static_ticker_div', false)}>{ETVConstants.trans('close')}</Button>
            <Button
              type="button"
              variant="contained"
              startIcon={<SaveIcon />}
              onClick={()=>this.saveNewTicker()}
              disabled={
                this.state.savingAdd ||
                !this.state.edit_value?.trim() ||
                !(Array.isArray(this.state.selected_screens) && this.state.selected_screens.length > 0)
              }
            >
              {this.state.savingAdd ? ETVConstants.trans('saving') : ETVConstants.trans('save')}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.window === 'edit_div'}
          maxWidth="sm"
          fullWidth
          onClose={() => {}} >
            <DialogTitle sx={{ pb: 1 }}>
              {this.state.edit_name}
                <Chip
                  label={ETVConstants.trans('edit_ticker')}
                  icon={<EditIcon />}
                  size="small"
                  sx={(t) => ({
                  borderRadius: 1,
                  fontWeight: 600,
                  backgroundColor: t.palette.action.hover,
                })}/>
            </DialogTitle>

          <DialogContent dividers>
            <Grid container spacing={2}>
              {/* Text */}
              <Grid item xs={12}>
                <TextField
                  id="ticker_text_edit"
                  label={ETVConstants.trans('ticker_text')}
                  multiline
                  minRows={4}
                  fullWidth
                  autoFocus
                  value={this.state.edit_value}
                  onChange={(e) => this.setState({ edit_value: e.target.value })}
                  placeholder={ETVConstants.trans('text_ticker')}
                  inputProps={{ maxLength: 500 }}
                  helperText={`${(this.state.edit_value || '').length}/500 `}
                />
              </Grid>

              {/* Font color */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth size="small">
                  <FormLabel sx={{ mb: 0.5 }}>{ETVConstants.trans('font_color')}</FormLabel>

                  <Stack direction="row" spacing={1.5} alignItems="center">
                    {/* Square swatch triggering hidden color input */}
                    <Box sx={{ position: 'relative', width: 40, height: 40, flex: '0 0 40px' }}>
                      <input
                        ref={this.fontColorRef}
                        type="color"
                        value={this.isValidHex(this.state.edit_textColor) ? this.state.edit_textColor : '#FFFFFF'}
                        onChange={(e) => this.setState({ edit_textColor: this.normHex(e.target.value) })}
                        style={{
                          position: 'absolute', inset: 0, opacity: 0,
                          width: '100%', height: '100%', cursor: 'pointer', border: 0, padding: 0,
                        }}
                        aria-label={ETVConstants.trans('font_color')}
                      />
                      <Box
                        onClick={() => this.fontColorRef.current?.click()}
                        sx={{
                          width: '100%', height: '100%', borderRadius: 1,
                          bgcolor: this.isValidHex(this.state.edit_textColor) ? this.state.edit_textColor : '#fff',
                          border: '1px solid', borderColor: 'divider',
                        }}
                      />
                    </Box>

                    {/* Hex input */}
                    <OutlinedInput
                      value={this.state.edit_textColor}
                      onChange={(e) => this.setState({ edit_textColor: this.normHex(e.target.value) })}
                      onBlur={(e) => this.setState({ edit_textColor: this.normHex(e.target.value) })}
                      size="small"
                      fullWidth
                      startAdornment={
                        <InputAdornment position="start">
                          <Box
                            sx={{
                              width: 16, height: 16, borderRadius: 0.5,
                              bgcolor: this.isValidHex(this.state.edit_textColor) ? this.state.edit_textColor : '#fff',
                              border: '1px solid', borderColor: 'divider',
                            }}
                          />
                        </InputAdornment>
                      }
                      error={!this.isValidHex(this.state.edit_textColor)}
                      sx={{
                        height: 40,                                 // match swatch height
                        '& .MuiInputBase-input': {
                          fontFamily:
                            'ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace',
                          textTransform: 'uppercase',
                          letterSpacing: 0.3,
                          py: 0.5,
                        },
                      }}
                    />
                  </Stack>

                  <FormHelperText error={!this.isValidHex(this.state.edit_textColor)}>
                    {!this.isValidHex(this.state.edit_textColor) ? ETVConstants.trans('invalid_hex') : ' '}
                  </FormHelperText>
                </FormControl>
              </Grid>

              {/* Background color */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth size="small">
                  <FormLabel sx={{ mb: 0.5 }}>{ETVConstants.trans('background_color')}</FormLabel>

                  <Stack direction="row" spacing={1.5} alignItems="center">
                    {/* Square swatch triggering hidden color input */}
                    <Box sx={{ position: 'relative', width: 40, height: 40, flex: '0 0 40px' }}>
                      <input
                        ref={this.bgColorRef}
                        type="color"
                        value={this.isValidHex(this.state.edit_bgColor) ? this.state.edit_bgColor : '#000000'}
                        onChange={(e) => this.setState({ edit_bgColor: this.normHex(e.target.value) })}
                        style={{
                          position: 'absolute', inset: 0, opacity: 0,
                          width: '100%', height: '100%', cursor: 'pointer', border: 0, padding: 0,
                        }}
                        aria-label={ETVConstants.trans('background_color')}
                      />
                      <Box
                        onClick={() => this.bgColorRef.current?.click()}
                        sx={{
                          width: '100%', height: '100%', borderRadius: 1,
                          bgcolor: this.isValidHex(this.state.edit_bgColor) ? this.state.edit_bgColor : '#000',
                          border: '1px solid', borderColor: 'divider',
                        }}
                      />
                    </Box>

                    {/* Hex input */}
                    <OutlinedInput
                      value={this.state.edit_bgColor}
                      onChange={(e) => this.setState({ edit_bgColor: this.normHex(e.target.value) })}
                      onBlur={(e) => this.setState({ edit_bgColor: this.normHex(e.target.value) })}
                      size="small"
                      fullWidth
                      startAdornment={
                        <InputAdornment position="start">
                          <Box
                            sx={{
                              width: 16, height: 16, borderRadius: 0.5,
                              bgcolor: this.isValidHex(this.state.edit_bgColor) ? this.state.edit_bgColor : '#000',
                              border: '1px solid', borderColor: 'divider',
                            }}
                          />
                        </InputAdornment>
                      }
                      error={!this.isValidHex(this.state.edit_bgColor)}
                      sx={{
                        height: 40,
                        '& .MuiInputBase-input': {
                          fontFamily:
                            'ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace',
                          textTransform: 'uppercase',
                          letterSpacing: 0.3,
                          py: 0.5,
                        },
                      }}
                    />
                  </Stack>

                  <FormHelperText error={!this.isValidHex(this.state.edit_bgColor)}>
                    {!this.isValidHex(this.state.edit_bgColor) ? ETVConstants.trans('invalid_hex') : ' '}
                  </FormHelperText>
                </FormControl>
              </Grid>

              {/* Text size */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth size="small">
                  <FormLabel sx={{ mb: 0.5 }}>{ETVConstants.trans('text_size')}</FormLabel>
                  <Select
                    id="text_size_id_edit"
                    value={this.state.edit_size}
                    onChange={(e) => this.setState({ edit_size: e.target.value })}
                    displayEmpty
                    inputProps={{ 'aria-label': ETVConstants.trans('text_size') }}
                    sx={{ height: 40, '& .MuiSelect-select': { py: 0.5 } }}
                  >
                    <MenuItem value="small">{ETVConstants.trans('small')}</MenuItem>
                    <MenuItem value="medium">{ETVConstants.trans('medium')}</MenuItem>
                    <MenuItem value="large">{ETVConstants.trans('large')}</MenuItem>
                    <MenuItem value="extra_large">{ETVConstants.trans('extra_large')}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* Alignment */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth size="small">
                  <FormLabel sx={{ mb: 0.5 }}>{ETVConstants.trans('alignment')}</FormLabel>
                  <Box sx={{ display: 'flex' }}>
                    <ToggleButtonGroup
                      value={this.state.align_top ? 'top' : 'bottom'}
                      exclusive
                      onChange={this.handleAlignChange}
                      size="small"
                      sx={{
                        '& .MuiToggleButton-root': {
                          height: 40,            // match Select height
                          px: 1.5,
                        },
                      }}
                    >
                      <ToggleButton value="top">
                        <AlignVerticalTopIcon sx={{ mr: 1 }} />
                        {ETVConstants.trans('top')}
                      </ToggleButton>
                      <ToggleButton value="bottom">
                        <AlignVerticalBottomIcon sx={{ mr: 1 }} />
                        {ETVConstants.trans('bottom')}
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                </FormControl>
              </Grid>


              {/* Preview */}
              <Grid item xs={12}>
                <Card variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden' }}>
                  <CardContent sx={{ pt: 1.5, pb: 1 }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                      <Typography variant="overline">{ETVConstants.trans('preview')}</Typography>
                      <Chip
                        size="small"
                        label={this.state.align_top ? ETVConstants.trans('top') : ETVConstants.trans('bottom')}
                        icon={this.state.align_top ? <AlignVerticalTopIcon /> : <AlignVerticalBottomIcon />}
                        variant="outlined"
                      />
                    </Stack>
                    <this.TickerPreview
                      text={this.state.edit_value}
                      bg={this.state.edit_bgColor}
                      fg={this.state.edit_textColor}
                      size={this.state.edit_size}
                      alignTop={this.state.align_top}
                    />
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button onClick={() => this.showWindow('edit_div', false)}>
              {ETVConstants.trans('close')}
            </Button>
            <Button
              onClick={() => this.updateTicker()}
              variant="contained"
              startIcon={<SaveIcon />}
              disabled={
                !(this.state.edit_value && this.state.edit_value.trim().length) ||
                !this.isValidHex(this.state.edit_textColor) ||
                !this.isValidHex(this.state.edit_bgColor)
              }
            >
              {ETVConstants.trans('save')}
            </Button>
          </DialogActions>
        </Dialog>


        {/* Info dialog */}
        <Dialog
          open={this.state.window === 'message_div'}
          maxWidth="xs"
          fullWidth
          onClose={() => this.setState({ window: '' })}
        >
          <DialogTitle>{this.state.info_title}</DialogTitle>
          <DialogContent>
            <Typography variant="body1">{this.state.info_message}</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.closeInfoMessage()}>{ETVConstants.trans('close')}</Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }
}

export default Newsticker;
